import { getToken, setToken } from './auth'
import { sendInviteOrIM } from '@/api/find'
const reg = {
  chinesePhone: /^1(10|3[0-9]|5[0-9]|8[0-9]|4[0-9]|7[0-9]|6[0-9]|9[0-9])\d{8}$/,
  phone: /[0-9-+]{4,}/,
  email: /^[A-Za-z0-9_\-.]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
  idcard: /(^\d{15}$)|(^\d{17}(\d|X|x)$)/,
  // fax:/^([0-9]{1,}[-]){1}([1-9][0-9]{4,11})([-][0-9]{0,6}){0,1}$/
  fax: /^([0-9]{1,4}[-]){1}([1-9][0-9]{4,11})([-][0-9]{0,6}){0,1}$/
}
const browser = (function() {
  let u = navigator.userAgent
  var ua = window.navigator.userAgent.toLocaleLowerCase(),
    ie11 = /(trident)\/([\d.]+)/
  // let isOpera = (!!window.opr && !!window.opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0
  // Firefox 1.0+
  let isFirefox = typeof InstallTrigger !== 'undefined'
  // Safari 3.0+ "[object HTMLElementConstructor]"
  let isSafari =
    /constructor/i.test(window.HTMLElement) ||
    (function(p) {
      return p.toString() === '[object SafariRemoteNotification]'
    })(!window['safari'] || (typeof safari !== 'undefined' && window.safari.pushNotification))
  // Internet Explorer 6-11
  let isIE = /*@cc_on!@*/ false || !!document.documentMode
  // Edge 20+
  let isEdge = !isIE && !!window.StyleMedia
  // Chrome 1 - 79
  let isChrome = u.indexOf('Chrome') && !!window.chrome
  // Edge (based on chromium) detection
  let isEdgeChromium = isChrome && navigator.userAgent.indexOf('Edg') != -1
  // Blink engine detection
  // let isBlink = (isChrome || isOpera) && !!window.CSS
  return {
    trident: u.indexOf('Trident') > -1, //IE内核
    presto: u.indexOf('Presto') > -1, //opera内核
    webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
    android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
    iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
    iPad: u.indexOf('iPad') > -1, //是否iPad
    webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
    weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
    qq: u.match(/\sQQ/i) == ' qq', //是否QQ
    ie: ua.match(ie11),
    isIE11: !!window.ActiveXObject || 'ActiveXObject' in window,
    isChrome: isChrome, //Chrome 1 - 79
    isFirefox: isFirefox, // Firefox 1.0+
    isSafari: isSafari, // Firefox 1.0+
    isIE: isIE, //Internet Explorer 6-11
    isEdge: isEdge,
    isEdgeChromium: isEdgeChromium
  }
})()

// first add raf shim
// http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
window.requestAnimFrame = (function() {
  return (
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    function(callback) {
      window.setTimeout(callback, 1000 / 60)
    }
  )
})()

// main function
const scrollToY = function(scrollTargetY, speed, easing) {
  // scrollTargetY: the target scrollY property of the window
  // speed: time in pixels per second
  // easing: easing equation to use

  let scrollY = window.scrollY
  scrollTargetY = scrollTargetY || 0
  speed = speed || 2000
  easing = easing || 'easeOutSine'
  let currentTime = 0

  // min time .1, max time .8 seconds
  var time = Math.max(0.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8))

  // easing equations from https://github.com/danro/easing-js/blob/master/easing.js
  // var PI_D2 = Math.PI / 2,
  const easingEquations = {
    easeOutSine: function(pos) {
      return Math.sin(pos * (Math.PI / 2))
    },
    easeInOutSine: function(pos) {
      return -0.5 * (Math.cos(Math.PI * pos) - 1)
    },
    easeInOutQuint: function(pos) {
      if ((pos /= 0.5) < 1) {
        return 0.5 * Math.pow(pos, 5)
      }
      return 0.5 * (Math.pow(pos - 2, 5) + 2)
    }
  }

  // add animation loop
  function tick() {
    currentTime += 1 / 60

    var p = currentTime / time
    var t = easingEquations[easing](p)

    if (p < 1) {
      window.requestAnimFrame(tick)

      window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t)
    } else {
      window.scrollTo(0, scrollTargetY)
    }
  }

  // call it once to get started
  tick()
}
// 邀约-IM 是否发送 站内信-短信-邮件
function inviteOrIM(param) {
  if (!param['url']) {
    param['url'] = location.href
  }
  param['language'] = param['language'] == 'en' ? 'en' : 'cn'
  try {
    sendInviteOrIM(param)
  } catch (error) {
    console.log(error, 'inviteOrIM')
  }
}
function getType(obj) {
  //tostring会返回对应不同的标签的构造函数
  var toString = Object.prototype.toString
  var map = {
    '[object Boolean]': 'boolean',
    '[object Number]': 'number',
    '[object String]': 'string',
    '[object Function]': 'function',
    '[object Array]': 'array',
    '[object Date]': 'date',
    '[object RegExp]': 'regExp',
    '[object Undefined]': 'undefined',
    '[object Null]': 'null',
    '[object Object]': 'object'
  }
  if (obj instanceof Element) {
    return 'element'
  }
  return map[toString.call(obj)]
}
function deepClone(data) {
  var type = getType(data)
  var obj
  if (type === 'array') {
    obj = []
  } else if (type === 'object') {
    obj = {}
  } else {
    //不再具有下一层次
    return data
  }
  if (type === 'array') {
    for (var i = 0, len = data.length; i < len; i++) {
      obj.push(deepClone(data[i]))
    }
  } else if (type === 'object') {
    for (var key in data) {
      obj[key] = deepClone(data[key])
    }
  }
  return obj
}

/* 格式化时间
 *  fmt: YYYY-mm-dd HH:MM:SS
 *  date: date对象 Object|String|Number
 *  return: 格式化时间
 */
function dateFormat(date, fmt='YYYY-mm-dd') {
  if (typeof date === 'string' || typeof date === 'number') {
    date = new Date(date)
  }
  let ret
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString(), // 秒
    'A+': date.getHours() > 12 ? "PM" : "AM" // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  }
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt)
    if (ret) {
      fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'))
    }
  }
  return fmt
}

/**
 * 更加屏幕宽度 算出广告位的宽度
 */
const calcAdvertisementWidth = function() {
  let screenWidth = document.body.scrollWidth || document.body.clientWidth || window.screen.width
  let aWidth = 200
  let cWidth = 1280
  let left = 0
  let right = 0
  if (screenWidth < 1775 && screenWidth >= 1520) {
    aWidth = (screenWidth - cWidth - 20) / 2
  } else if (screenWidth < 1520) {
    aWidth = (1520 - cWidth - 20) / 2
  }

  left = right = (screenWidth - cWidth) / 2 - aWidth - 5
  if (left < 0) {
    left = right = 0
  }

  return {
    width: aWidth,
    left,
    right
  }
}

/**
 * 函数节流
 */
const throttle = function(fn, wait = 500) {
  let flg = true // 通过闭包保存一个标记
  return function() {
    if (!flg) return
    flg = false
    setTimeout(() => {
      // 将外部传入的函数的执行放在setTimeout中
      fn.apply(this, arguments)
      // 最后在setTimeout执行完毕后再把标记设置为true(关键)表示可以执行下一次循环了。当定时器没有执行的时候标记永远是false，在开头被return掉
      flg = true
    }, wait)
  }
}

// 给图片添加压缩
function compressImage(img, w = 200, h = 200) {
  if (typeof img !== 'string' || !img) return img
  if (!w) w = 200
  if (!h) h = 200
  if (img.indexOf('oss-') > 1 && img.indexOf('aliyuncs.com') > 1) {
    img = img + `?x-oss-process=image/resize,limit_0,m_fill,w_${w},h_${h}/quality,q_100`
  }
  return img
}

export { reg, getToken, setToken, browser, scrollToY, inviteOrIM, deepClone, getType, dateFormat, calcAdvertisementWidth, throttle, compressImage }
